import React from "react";
import { DataObject } from "@mui/icons-material";
import { Grid, MenuItem, Typography } from "@mui/material";
import CustomTextField from "../../../../../components/common/Textfield";
import { SCHEMA_TYPE_OPTIONS, SEOForm } from "../../types";
import SectionCard from "./SectionCard";

interface SchemaMarkupCardProps {
  form: SEOForm;
  onChange: <K extends keyof SEOForm>(field: K, value: SEOForm[K]) => void;
}

const SchemaMarkupCard: React.FC<SchemaMarkupCardProps> = ({
  form,
  onChange,
}) => (
  <SectionCard icon={<DataObject color="primary" />} title="Schema Markup">
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 6 }}>
        <CustomTextField
          select
          label="Schema Type"
          value={form.schemaType}
          onChange={(event) => onChange("schemaType", event.target.value)}
        >
          {SCHEMA_TYPE_OPTIONS.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </CustomTextField>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Typography variant="caption" color="text.secondary">
          Structured data helps search engines understand your content.
        </Typography>
      </Grid>
    </Grid>
  </SectionCard>
);

export default SchemaMarkupCard;
